import React from 'react';
import { AlertCircle, X } from 'lucide-react';
import { Button } from '../ui/button';

const VerificationBanner = ({ user, onStartVerification, onDismiss }) => {
  // Check both camelCase and snake_case verification status (backend uses snake_case)
  const verificationStatus = user?.verificationStatus || user?.verification_status;
  
  if (verificationStatus === 'verified') return null;

  const getMessageByStatus = () => {
    switch (verificationStatus) {
      case 'pending':
        return {
          title: 'Complete Verification',
          description: `You need to verify your identity to start ${user.role === 'driver' ? 'accepting' : 'booking'} rides`,
          action: 'Start Verification',
          color: 'yellow'
        };
      case 'pending_review':
        return {
          title: 'Verification Under Review',
          description: 'Your documents are being reviewed. We\'ll notify you within 24 hours.',
          action: null,
          color: 'blue'
        };
      case 'rejected':
        return {
          title: 'Verification Required',
          description: 'There was an issue with your verification. Please resubmit your documents.',
          action: 'Resubmit Documents',
          color: 'red'
        };
      default:
        return {
          title: 'Complete Verification',
          description: `Verify your account to start ${user.role === 'driver' ? 'accepting' : 'booking'} rides`,
          action: 'Start Verification',
          color: 'yellow'
        };
    }
  };

  const message = getMessageByStatus();
  const bgColors = {
    yellow: 'bg-yellow-50 border-yellow-300',
    blue: 'bg-blue-50 border-blue-300',
    red: 'bg-red-50 border-red-300'
  };
  const textColors = {
    yellow: 'text-yellow-800',
    blue: 'text-blue-800',
    red: 'text-red-800'
  };
  const iconColors = {
    yellow: 'text-yellow-600',
    blue: 'text-blue-600',
    red: 'text-red-600'
  };

  return (
    <div className={`${bgColors[message.color]} border-2 rounded-lg p-4 mb-6 animate-fade-in`}>
      <div className="flex items-start space-x-3">
        <AlertCircle className={`w-5 h-5 ${iconColors[message.color]} mt-0.5 flex-shrink-0`} />
        <div className="flex-1">
          <h3 className={`font-bold ${textColors[message.color]} mb-1`}>{message.title}</h3>
          <p className={`text-sm ${textColors[message.color]} mb-3`}>{message.description}</p>
          {message.action && (
            <Button
              onClick={onStartVerification}
              className="bg-green-600 hover:bg-green-700 text-white font-semibold"
              size="sm"
            >
              {message.action}
            </Button>
          )}
        </div>
        {onDismiss && verificationStatus === 'pending_review' && (
          <button onClick={onDismiss} className="text-gray-400 hover:text-gray-600">
            <X className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  );
};

export default VerificationBanner;